import { render, staticRenderFns } from "./promotional-discounts.vue?vue&type=template&id=015b5d66&scoped=true"
import script from "./promotional-discounts.vue?vue&type=script&lang=js"
export * from "./promotional-discounts.vue?vue&type=script&lang=js"
import style0 from "./promotional-discounts.vue?vue&type=style&index=0&id=015b5d66&prod&scoped=true&lang=css"
import style1 from "./promotional-discounts.vue?vue&type=style&index=1&id=015b5d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b5d66",
  null
  
)

export default component.exports